<template>
    <div class="content-wrapper">
        <div class="user-profile mb-primary">
            <div class="card position-relative card-with-shadow pt-4 pb-4 border-0">
                <app-overlay-loader v-if="componentLoader" class="h-100"/>
                <div v-else class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
                        <div class="media border-right px-5 pr-xl-5 pl-xl-0 align-items-center user-header-media">


                            <form class="mb-0" ref="form" data-url="admin/auth/users/profile-picture"
                                  :class="{'loading-opacity': preloader}">
                                <div class="profile-pic-wrapper position-relative">

                                    <app-overlay-loader v-if="preloader"/>
                                    <app-input v-else
                                               id="user_image"
                                               class="circle mx-xl-auto"
                                               :wrapper-class="'circle mx-xl-auto'"
                                               name="user_image"
                                               type="custom-file-upload"
                                               v-model="user.profile_picture"
                                               :generate-file-url="false"
                                               @change="setProfilePicture"
                                               :label="$t('change')"/>
                                </div>
                            </form>
                            <div class="media-body user-info-header">
                                <h5>
                                    {{ user.loggedInUser.full_name }}
                                </h5>
                                <p class="text-muted mb-2">{{ user.loggedInUser.email }}</p>
                                <span v-if="userInfo.roles[0].pivot.role_id < 5" class="badge badge-pill badge-success user-status">
                                    {{ userInfo.roles[0].name }}
                                </span>

                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                        <div class="user-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <h4 v-if="!user.loggedInUser.address">
                                        <b>{{ $t('gdpr_approval') }}</b>
                                    </h4>
                                    <!-- @todo: po spusteni vstupnich dotazniku zjistit jestli jsou vyplnena pole, pokud ne, zobrazit ze je nutne vyplnit dotaznik + otevrit automaticky dotaznik -->

                                    <h4 v-else-if="userInfo.roles[0].pivot.role_id == 5 && !user.loggedInUser.first_name" class="mb-5">
                                        <b>{{ $t('welcome_fill_questionnaire') }}</b>
                                    </h4>

                                    <h4 v-else-if="candidateOptions.timeline_state == 7 && candidateOptions.event_date">
                                        <b>{{ $t('we_are_looking_forward_to_seeing_you_on') }}</b><br>
                                        {{ $t('employment_date_is_coming') }}
                                        {{ formatEventDate(candidateOptions.event_date) }} 
                                    </h4>

                                    <h4 v-else-if="userInfo.roles[0].pivot.role_id == 5" class="mb-0">
                                        <b>{{ $t('welcome_onboard') }}</b>
                                    </h4>
                                    <h4 v-else class="mb-0">
                                        <b>{{ $t('welcome_onboard') }}</b><br>
                                    </h4>

                                    


                                    <div v-if="!user.loggedInUser.address" class="media mb-1 mt-4 mb-xl-0">
                                        <div class="" @click="gdprApprove()">
                                            <app-input id="checkbox_gdpr"
                                                type="checkbox"
                                                :list="gdprSelection"
                                                v-model="approval"
                                                />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        

        <!-- @todo: doplnit jinou podminku nez date_of_birth jako kontrolu jestli je questionnaire doplneny -->
        <!-- <app-tab v-if="userInfo.roles[0].pivot.role_id == 5 && user.loggedInUser.address && !user.loggedInUser.first_name" :tabs="tabsOnboardeeQuestionnaire" :icon="tabIcon"/>
        <app-tab v-if="userInfo.roles[0].pivot.role_id == 5 && user.loggedInUser.address" :tabs="tabsOnboardee" :icon="tabIcon"/>-->
        <app-tab v-if="user.loggedInUser.address" :tabs="tabs" :icon="tabIcon"/>



        <!-- Hidden form for GDPR submit -->
        <div style="display:none;">
            <message v-if="!user.loggedInUser.address"></message>
        </div>



        <div class="row text-muted">
        <div v-if="user.loggedInUser.address" class="mt-3 w-100 text-center small mr-3" :class="{'disabled': approval != '1'}">

            <div class="media-body">
                <p class="text-muted mb-0">{{ $t('gdpr_signed') }}: {{ user.loggedInUser.contact }}, IP:
                {{
                        user.loggedInUser.address ? user.loggedInUser.address : $t('not_available')
                }}
                </p>
            </div>
        </div>
    </div>


    </div>
</template>

<script>

import {FormMixin} from "../../../../core/mixins/form/FormMixin";
import {UserMixin} from "./Mixins/UserMixin";
import * as actions from "../../../Config/ApiUrl";

export default {
    name: "Profile",
    mixins: [FormMixin, UserMixin],
    watch: {
      userInfo: {
        immediate: true,
        handler (val, oldVal) {

            // If new file has been uploaded
            if(oldVal){
                console.log("has user"+val.candidate_id);
                console.log("has user2"+val.address);
                this.selectedId = val.candidate_id;
                this.getCandidateByUserId();
            }

        }
      }
    },
    data() {
        return {
            preloader: false,
            finishedGetData: false,
            tabIcon: 'user',
            tabsOnboardeeQuestionnaire: [
                {
                    'name': this.$t('message'),
                    'title': this.$t('message'),
                    'component': 'message',
                    'permission': ''
                },
                {
                    'name': this.$t('my_onboarding'),
                    'title': this.$t('my_onboarding'),
                    'component': 'app-onboarding-site-editor',
                    'permission': ''
                },
                {
                    'name': this.$t('password_change'),
                    'title': this.$t('password_change'),
                    'component': 'password-change',
                    'permission': ''
                },

            ],
            tabsOnboardee: [
                // {
                //     'name': this.$t('my_onboarding'),
                //     'title': this.$t('my_onboarding'),
                //     'component': 'app-onboarding-site-editor',
                //     'permission': ''
                // },
                // {
                //     'name': this.$t('message'),
                //     'title': this.$t('message'),
                //     'component': 'message',
                //     'permission': ''
                // },
                // {
                //     'name': this.$t('password_change'),
                //     'title': this.$t('password_change'),
                //     'component': 'password-change',
                //     'permission': ''
                // },
                {
                    'name': this.$t('my_onboarding'),
                    'title': this.$t('my_onboarding'),
                    'component': 'app-onboarding-site-editor',
                    'permission': ''
                },
                {
                    'name': this.$t('personal_data'),
                    'title': this.$t('personal_data'),
                    'component': 'message',
                    'permission': ''
                },
                {
                    'name': this.$t('password_change'),
                    'title': this.$t('password_change'),
                    'component': 'password-change',
                    'permission': ''
                },
            ],
            tabs: [
                {
                    'name': this.$t('personal_data'),
                    'title': this.$t('personal_data'),
                    'component': 'message',
                    'permission': ''
                },
                {
                    'name': this.$t('password_change'),
                    'title': this.$t('password_change'),
                    'component': 'password-change',
                    'permission': ''
                },

            ],
            approvalApproved: ["1"],
            approval: '',
            gdprSelection: [
                {id: '1', value: this.$t('gdpr_approve')},
            ],

            selectedId: 1,
            selectedSiteUrl: "",
            impersonate: true,
            selectedAction: '',
            timelineCandidates: [],
            timelineStates: [],
            candidateOptions: [],
            courseOptions: [],
            filterOptions: [
                {id: '7', value: 'Před nástupem'},
                {id: '8', value: 'První den'},
                {id: '9', value: 'Zkušební doba'},
                {id: '10', value: 'Zaměstnání'},
                {id: '11', value: 'Povýšení'},
                {id: '12', value: 'Mateřská'},
                {id: '13', value: 'Offboarding'},
            ],
            allFilterValues: {
                "filter_with_status": 3,
                "filter_with_timeline_state": 7,
            },
        }
    },

    created() {
        //this.getTimelineStateNames();

    },

    mounted(){
        if(location.href.indexOf('localhost') != -1){
            this.localhost = true;
        } else {
            this.localhost = false;
        }



    },


    methods: {
        /**
         * Get Additional Data
         * */
        getUrlParameter(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        },
        beforeSubmit() {
            this.preloader = true;
        },
        setProfilePicture($event) {
            const fileValue = $event.target.files[0];
            let formData = new FormData();
            formData.append('profile_picture', fileValue);
            this.save(formData);
        },
        afterFinalResponse() {
            this.preloader = false;
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
            window.location = actions.MY_PROFILE;
        },
        gdprApprove() {
            $('form.personal-info button').trigger('click');
        },



        /**
         * Calendar
         */

        formatEventDate(date) {
        let formattedDate = ' – '+this.$t('no_date');
            if(date){
                formattedDate = moment(date).format('DD. MM. HH:mm');
                this.hasEventDate = true;
            }
            return formattedDate;

        },


    }
}
</script>
<style scoped>
    .user-profile .card{
        min-height: 190px;
    }
</style>
